<template>
    <rkm-modal
        :loading="loading"
        :title="`Materiais (${grupo.nome})`"
        large
        persistent
        ref="Modal"
    >
        <rkm-table
            :fields="fields"
            :items="materiais"
            class="table-materiais"
        >
            <template v-slot:cell(estoqueMinimo)="{ item }">
                <rkm-form-input
                    :validations="getValidations(item).estoqueMinimo"
                    class="my-auto estoque"
                    name="Estoque mínimo"
                    number
                    v-model="item.estoqueMinimo"
                />
            </template>

            <template v-slot:cell(estoqueMaximo)="{ item }">
                <rkm-form-input
                    :validations="getValidations(item).estoqueMaximo"
                    class="my-auto estoque"
                    name="Estoque máximo"
                    number
                    v-model="item.estoqueMaximo"
                />
            </template>
        </rkm-table>

        <template #footer>
            <rkm-button
                :disabled="!!loading"
                @click="handleExit"
            >
                Cancelar
            </rkm-button>

            <rkm-button
                :disabled="!!loading"
                @click="save"
                color="primary"
            >
                Salvar
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Vuex.
import { mapGetters } from 'vuex'

// Others.
import { object } from '@/mixins'

export default {
    computed: {
        ...mapGetters({ loading: 'getLoading' }),
        fields() {

            return [
                {
                    key: 'codigo',
                    label: 'Código',
                    sortable: true,
                    class: 'col-min'
                },
                {
                    key: 'descricao',
                    label: 'Descrição',
                    sortable: true,
                },
                {
                    key: 'subgrupoNome',
                    label: 'Subgrupo',
                    sortable: true,
                },
                {
                    key: 'estoqueMinimo',
                    label: 'Estoque mínimo',
                    class: 'col-min'
                },
                {
                    key: 'estoqueMaximo',
                    label: 'Estoque máximo',
                    class: 'col-min'
                },
            ]
        },
    },
    data: () => ({
        grupo: {},
        materiais: [],
    }),
    methods: {
        getValidations(item) {

            const estoqueMinimo = parseInt(item.estoqueMinimo)
            const estoqueMaximo = parseInt(item.estoqueMaximo)

            return {
                estoqueMinimo: {
                    max: 8,
                    min_value: 0,
                    max_value: isNaN(estoqueMaximo) ? 99999999 : estoqueMaximo,
                },
                estoqueMaximo: {
                    max: 8,
                    min_value: isNaN(estoqueMinimo) ? 0 : estoqueMinimo,
                    max_value: 99999999,
                }
            }
        },
        open(grupo) {

            this.grupo = grupo
            this.materiais = this.clone(grupo.materiais)

            this.$refs.Modal.show()
        },
        handleExit() {

            this.$refs.Modal.hide()
        },
        save() {

            this.grupo.materiais = this.clone(this.materiais)

            this.$refs.Modal.hide()
        },
    },
    mixins: [object],
}
</script>

<style scoped>
.table-materiais >>> .estoque { min-width: 120px; }
</style>